import { ReportSection } from "../ReportSection";
import { fmtDate } from "./formatters";

interface TimelineRow {
  id: string;
  name: string;
  startDate: string | null;
  endDate: string | null;
  status: string;
  progress: number;
  phases: Array<{
    name: string;
    startDate: string | null;
    endDate: string | null;
    status: string;
    progress: number;
  }>;
  milestones: Array<{ title: string; dueDate: string | null; status: string }>;
}

const PHASE_COLOR: Record<string, string> = {
  completed: "hsl(142,72%,40%)",
  in_progress: "hsl(210,100%,50%)",
  active: "hsl(210,100%,50%)",
  pending: "hsl(210,16%,80%)",
  cancelled: "hsl(0,72%,55%)",
};

export function ProjectTimelineReport({ data }: { data: TimelineRow[] }) {
  if (data.length === 0) {
    return (
      <div className="rounded-xl border bg-white py-12 text-center text-sm text-muted-foreground"
        style={{ borderColor: "hsl(210,30%,85%)" }}>
        No projects available for timeline view.
      </div>
    );
  }
  return (
    <div className="space-y-4">
      {data.map((p) => {
        const totalPhases = p.phases.length;
        return (
          <ReportSection
            key={p.id}
            title={p.name}
            subtitle={`${fmtDate(p.startDate)} → ${fmtDate(p.endDate)} · ${p.progress}% complete`}
          >
            {totalPhases > 0 ? (
              <div className="flex h-9 overflow-hidden rounded-md">
                {p.phases.map((ph, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-center text-[11px] font-medium text-white"
                    style={{
                      flex: 1,
                      background:
                        PHASE_COLOR[ph.status] ?? "hsl(210,16%,80%)",
                    }}
                    title={`${ph.name} (${ph.status})`}
                  >
                    {ph.name}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-sm text-muted-foreground">No phases defined</div>
            )}

            {p.milestones.length > 0 && (
              <div className="mt-3">
                <div className="mb-1 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
                  Milestones
                </div>
                <ul className="grid gap-1 md:grid-cols-2">
                  {p.milestones.slice(0, 8).map((m, idx) => (
                    <li
                      key={idx}
                      className="flex items-center justify-between text-[12px]"
                    >
                      <span className="truncate text-foreground">
                        ◆ {m.title}
                      </span>
                      <span className="ml-2 shrink-0 text-muted-foreground">
                        {fmtDate(m.dueDate)}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </ReportSection>
        );
      })}
    </div>
  );
}
